import styled from 'styled-components';
export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1rem 0;
`;